module.exports = __webpack_public_path__ + "img/16.3d25ec7a.jpeg";